import { Svg } from './svg'

export const SettingsIcon = () => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99999 6C6.89543 6 5.99999 6.89543 5.99999 8C5.99999 9.10457 6.89543 10
      7.99999 10C9.10456 10 9.99999 9.10457 9.99999 8C9.99999 6.89543 9.10456 6 7.99999 6Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.78072 0C6.40412 0 5.20417 0.93689 4.8703 2.27239L4.81676 2.48656L4.60451 2.42584C3.28099
      2.04723 1.86964 2.61797 1.18134 3.81015L0.962119 4.18985C0.273818 5.38203 0.485214 6.88966 1.47485
      7.84655L1.63353 7.99997L1.4748 8.15345C0.485162 9.11034 0.273764 10.618 0.962065 11.8101L1.18129
      12.1899C1.86959 13.382 3.28094 13.9528 4.60445 13.5742L4.81675 13.5134L4.87029 13.7276C5.20417
      15.0631 6.40412 16 7.78072 16H8.21917C9.59577 16 10.7957 15.0631 11.1296 13.7276L11.1831 13.5134L11.3954
      13.5742C12.7189 13.9528 14.1302 13.382 14.8185 12.1899L15.0377 11.8101C15.7261 10.618 15.5147 9.11034
      14.525 8.15345L14.3663 7.99997L14.525 7.84655C15.5146 6.88966 15.726 5.38203 15.0377 4.18986L14.8185
      3.81015C14.1302 2.61798 12.7188 2.04723 11.3953 2.42584L11.1831 2.48653L11.1296 2.27239C10.7957 0.936891
      9.59577 0 8.21917 0H7.78072ZM4.05445 4.34871C3.61328 4.22251 3.14283 4.41276 2.91339 4.81015L2.69417
      5.18985C2.46474 5.58724 2.5352 6.08979 2.86508 6.40875L4.02704 7.53227C4.00917 7.6857 3.99999 7.84178
      3.99999 8C3.99999 8.15821 4.00917 8.31427 4.02704 8.46769L2.86503 9.59125C2.53515 9.91021 2.46468
      10.4128 2.69412 10.8101L2.91334 11.1899C3.14277 11.5872 3.61322 11.7775 4.05439 11.6513L5.60855
      11.2067C5.85779 11.3929 6.12946 11.5507 6.41877 11.6753L6.81058 13.2425C6.92187 13.6877 7.32185
      14 7.78072 14H8.21917C8.67803 14 9.07802 13.6877 9.18931 13.2425L9.5811 11.6754C9.87044 11.5507
      10.1421 11.3929 10.3914 11.2067L11.9454 11.6513C12.3866 11.7775 12.857 11.5872 13.0865 11.1899L13.3057
      10.8101C13.5351 10.4128 13.4647 9.91021 13.1348 9.59125L11.9729 8.46782C11.9908 8.31437 12 8.15826
      12 8C12 7.84173 11.9908 7.6856 11.9729 7.53213L13.1347 6.40875C13.4646 6.08979 13.5351 5.58724
      13.3056 5.18985L13.0864 4.81015C12.857 4.41276 12.3865 4.22251 11.9454 4.34871L10.3914 4.79325C10.1421
      4.60708 9.87044 4.44928 9.58111 4.32464L9.18931 2.75746C9.07802 2.3123 8.67804 2 8.21917 2H7.78072C7.32186
      2 6.92187 2.3123 6.81058 2.75746L6.41878 4.32468C6.12947 4.44932 5.8578 4.60711 5.60856 4.79328L4.05445 4.34871Z"
      fill="currentColor"
    />
  </Svg>
)
